import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreIconSmall from '@wix/da-ds/pkg/Icons/CoreIconSmall';
import s from './CoreMenuItem.scss';
var CoreMenuItem = function (_a) {
    var className = _a.className, hasCoreMembership = _a.hasCoreMembership, coreLevel = _a.coreLevel;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var buyCoreKey = isMobile
        ? 'siteHeaderMobile.userMenu.buyCoreMembership'
        : 'siteHeader.buyCoreMembership';
    return (React.createElement("div", { className: classnames(s['root'], className, hasCoreMembership && coreLevel && s["package-" + coreLevel]) },
        React.createElement("span", null, hasCoreMembership && coreLevel
            ? t("siteHeader.userMenu.coreLabel." + coreLevel)
            : t(buyCoreKey)),
        React.createElement("span", null,
            React.createElement(CoreIconSmall, { className: s['core-icon'], circleClassName: s['core-icon-circle'] }))));
};
CoreMenuItem.displayName = 'CoreMenuItem';
export default CoreMenuItem;
//# sourceMappingURL=CoreMenuItem.js.map